import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RecordedInterview from './recorded-interview';
import RecordedInterviewDetail from './recorded-interview-detail';
import RecordedInterviewUpdate from './recorded-interview-update';
import RecordedInterviewDeleteDialog from './recorded-interview-delete-dialog';

const RecordedInterviewRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RecordedInterview />} />
    <Route path="new" element={<RecordedInterviewUpdate />} />
    <Route path=":id">
      <Route index element={<RecordedInterviewDetail />} />
      <Route path="edit" element={<RecordedInterviewUpdate />} />
      <Route path="delete" element={<RecordedInterviewDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RecordedInterviewRoutes;
